import { render, staticRenderFns } from "./MachineLearningView.vue?vue&type=template&id=1670c25c&scoped=true"
import script from "./MachineLearningView.vue?vue&type=script&lang=js"
export * from "./MachineLearningView.vue?vue&type=script&lang=js"
import style0 from "./MachineLearningView.vue?vue&type=style&index=0&id=1670c25c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1670c25c",
  null
  
)

export default component.exports